let view = null;

export default {
	namespace: 'template-events',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: EventsView } = await import(
			/* webpackChunkName: "events-view" */ '../../templates/EventsView'
		);
		view = new EventsView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
